import React from 'react';

/**
 * Themed shield glyph used in the 2FA screens.
 * Inherits color via `currentColor` from the `.tf-shield` badge.
 */
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M12 2.5 4.5 5.5v5.2c0 4.5 3.1 8.7 7.5 10 4.4-1.3 7.5-5.5 7.5-10V5.5L12 2.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="m8.8 12 2.1 2.1 4.3-4.3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShieldIcon;
